import React from "react"
import { motion } from "framer-motion"
import { PaddedContainer, FlexContainer, Heading, ParaText, BlueText, IconContainer } from "../styles/Global.styles"
import { ParticleContainer, ImageCard, Particle } from "../styles/Presentation.styles"
import { BsGithub, BsLinkedin } from "react-icons/bs"
import Image from "../assets/myimage.png"
import ParticleImg from "../assets/particle.png"
import { fadeInLeft, fadeInRight } from "../utils/MotionVariants"

const Presentation = () => {
  return (
    <PaddedContainer
        id="Home"
        top="8%"
        right="10%"
        left="3%"
        bottom="8%"
        responsiveLeft="1rem"
        responsiveRight="1rem"
        responsiveTop="8rem"
        
    >
        <FlexContainer fullWidthChild>
            <motion.div
                variants={fadeInLeft}
                initial="hidden"
                whileInView="visible"
            >
                <Heading
                    size="h3"
                    as="h3"
                ><BlueText>Hi</BlueText> everyone!</Heading>
                <Heading
                    size="h2"
                    as="h2"
                    top="0.5rem"
                    bottom="1rem"
                >I'm <BlueText>Soualah Mohammed</BlueText> Zakaria
                </Heading>
                <Heading
                    size="h3"
                    as="h3"
                >
                    a <BlueText>CS Student</BlueText> and <BlueText>Developer</BlueText>.
                </Heading>
                <ParaText 
                    as="p" 
                    top="2rem" 
                    bottom="3rem"
                >Hello, I'm Soualah Mohammed Zakaria, a Computer Science student at the Higher National School of Computer Science (ESI) with two years of professional experience as a developer. My passion lies in technology, particularly in data science, cybersecurity, and electrical engineering. I am committed to continuous learning and skill enhancement, and I’m actively seeking opportunities to engage in exciting projects and collaborate with clients and fellow developers.
                </ParaText>
                <FlexContainer gap="10px" responsiveFlex>
                    <IconContainer as="a" href="https://linkedin.com/in/soualahmohammedzakaria/" target="_blank" color="blue" size="2rem">
                        <BsLinkedin />
                    </IconContainer>
                    <IconContainer as="a" href="https://github.com/soualahmohammedzakaria" target="_blank" color="blue" size="2rem">
                        <BsGithub />
                    </IconContainer>
                </FlexContainer>
            </motion.div>
            <FlexContainer 
                justify="flex-end"
                as={motion.div}
                variants={fadeInRight}
                initial="hidden"
                whileInView="visible"
            >
                <PaddedContainer top="3.4rem">
                    <ParticleContainer>
                        <ImageCard>
                            <img src={Image} alt="Me" />
                        </ImageCard>

                        <Particle
                            as={motion.img}
                            animate={{
                                x: [0, 100, 0],
                                rotate: 360,
                                scale: [1, 0.5, 1],
                            }}
                            transition={{
                                duration: 20,
                                repeat: Infinity,
                            }}
                            src={ParticleImg}
                            alt="Particle"
                            top="-70px"
                            left="20px"
                            rotate="60deg"
                        />
                        <Particle
                            as={motion.img}
                            animate={{
                                y: [0, 100, 0],
                                rotate: 360,
                                scale: [1, 0.8, 1],
                            }}
                            transition={{
                                duration: 18,
                                repeat: Infinity,
                            }}
                            src={ParticleImg}
                            alt="Particle"
                            top="50px"
                            right="-70px"
                            rotate="0deg"
                        />
                        <Particle
                            as={motion.img}
                            animate={{
                                y: [0, -100, 0],
                                rotate: 360,
                                scale: [1, 0.9, 1],
                            }}
                            transition={{
                                duration: 18,
                                repeat: Infinity,
                            }}
                            src={ParticleImg}
                            alt="Particle"
                            bottom="160px"
                            left="-70px"
                            rotate="40deg"
                        />
                    </ParticleContainer>
                </PaddedContainer>
            </FlexContainer>
        </FlexContainer>
    </PaddedContainer>
  )
}

export default Presentation